export default {
    url: "https://qwqq.org/api.php",
}



// WEBPACK FOOTER //
// ./src/config.js